import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { url } from 'inspector';
import { take } from 'rxjs/operators';
import { CartService } from 'src/app/services/cart/cart.service';
import { ProductService } from 'src/app/services/product-service/product.service';
import { ShopServiceService } from 'src/app/services/shop-service.service';
import { Product } from '../models/type/product.model';
import { Shop } from '../models/type/shop.model';

@Component({
  selector: 'app-products',
  templateUrl: './products.page.html',
  styleUrls: ['./products.page.scss'],
})
export class ProductsPage implements OnInit {
  // shop: Shop;
  // shops: Shop[] = [];
  shop;
  shops = [];
  id;
  products: Product[] = [];
  constructor(
    private shopService: ShopServiceService,
    private activatedRoute: ActivatedRoute,
    private productService: ProductService,
    private cartService: CartService,
    private router: Router,
    private location: Location
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    // this.shop = this.shopService.getShop(this.id);
    this.shopService
      .getShop(this.id)
      .pipe(take(1))
      .subscribe((res) => {
        if (res.exists) {
          this.shop = res.data();
          console.log(this.shop);

          this.productService.getStorePoducts(this.shop.id).subscribe((res) => {
            this.products = res.map(
              (product) => product.payload.doc.data() as Product
            );
            // console.log(this.products);
          });
        }
      });
    // this.products = this.productServe.getPoducts();

    // this.productService.getStorePoducts(this.shop.ownerID).subscribe((res) => {
    //   this.products = res.map(
    //     (product) => product.payload.doc.data() as Product
    //   );
    //   console.log(this.products);
    // });

    // this.shops = this.shopServe.getShops();
    this.shopService.getShops().subscribe((res) => {
      this.shops = res.map((shop) => {
        shop.payload.doc.data() as Shop;
      });
    });
  }

  goToShops() {
    // this.router.navigate(['home/all-shops']);
    this.location.back();
  }
}
